import Deposit from "../assets/images/deposit.png";
import Download from "../assets/images/download.png";
import MoneyBag from "../assets/images/money-bag.png";
import ClockTime from "../assets/images/clock-time.png";

const Service = () => {
    const services = [
        {
            icon: Deposit,
            value: "₹100",
            label: "Minimum Deposit",
            alt: "Minimum deposit"
        },
        {
            icon: Download,
            value: "300K+",
            label: "Downloads",
            alt: "App downloads"
        },
        {
            icon: ClockTime,
            value: "Daily",
            label: "Fast & Accurate Results",
            alt: "Fast and accurate results"
        },
        {
            icon: MoneyBag,
            value: "₹100",
            label: "Minimum Withdrawal",
            alt: "Minimum withdrawal"
        }
    ];

    return (
        <section className="service-section">
            <div className="container">
                <div className="row g-4">
                    {services.map((service, index) => (
                        <div className="col-md-3 col-sm-6" key={index}>
                            <div className="service-item">
                                <div className="service-icon-box">
                                    <img
                                        src={service.icon}
                                        alt={service.alt}
                                        className="service-img"
                                    />
                                </div>
                                <div className="service-text">
                                    <h3 className="service-number">{service.value}</h3>
                                    <p className="service-desc">{service.label}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Service;
